"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var resolverCenter_1 = __importDefault(require("./resolverCenter"));
var resolverCenterHorizontal_1 = __importDefault(require("./resolverCenterHorizontal"));
var resolverCenterVertical_1 = __importDefault(require("./resolverCenterVertical"));
var resolverTopLeft_1 = __importDefault(require("./resolverTopLeft"));
var resolverTopRight_1 = __importDefault(require("./resolverTopRight"));
var resolverBottomLeft_1 = __importDefault(require("./resolverBottomLeft"));
var resolverBottomRight_1 = __importDefault(require("./resolverBottomRight"));
var resolvers = [
    resolverCenter_1.default,
    resolverCenterVertical_1.default,
    resolverCenterHorizontal_1.default,
    resolverTopLeft_1.default,
    resolverTopRight_1.default,
    resolverBottomLeft_1.default,
    resolverBottomRight_1.default,
];
function positionResolver(opts) {
    var pos;
    resolvers.some(function (resolver) {
        var ret = resolver(opts);
        if (ret) {
            pos = ret;
            return true;
        }
        return false;
    });
    if (pos) {
        return pos;
    }
    return {
        left: 0,
        top: 0,
    };
}
exports.default = positionResolver;
//# sourceMappingURL=positionResolver.js.map